import { useState, type FormEvent } from 'react';
import { Icon } from './Icon.js';

type Props = {
  onSubmit: (raw: string) => void;
  disabled?: boolean;
};

export function SearchBar({ onSubmit, disabled }: Props): JSX.Element {
  const [value, setValue] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (disabled) return;
    const v = value.trim();
    if (v.length === 0) return;
    onSubmit(v);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <label className="flex items-center gap-3 rounded-2xl bg-surface border border-border px-4 h-12">
        <Icon name="search" size={20} className="text-secondary shrink-0" />
        <input
          type="search"
          inputMode="search"
          enterKeyHint="search"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          placeholder="电影名 或 剧集 S02E05"
          value={value}
          disabled={disabled}
          onChange={(e) => setValue(e.target.value)}
          className="flex-1 bg-transparent text-primary placeholder:text-muted text-[16px]"
        />
      </label>
    </form>
  );
}
